module.exports = __webpack_public_path__ + "media/new/pay-mycrypto-699e54f5.svg";